export class AsyncOperationData {
	additionalData1: string;
	additionalData2: string;
	additionalData3: string;
	beanDefToExecution: string;
	creDate: Date;
	creUser: string;
	errorMessage: string;
	executionTime: number;
	explanation: string;
	id: string;
	lastOperationDate: Date;
	orgId: string;
	source: string;
	status: AsyncOperationDataStatus;
	updDate: Date;
	updUser: string;
}

export enum AsyncOperationDataStatus {
	COMPLETED = 'COMPLETED',
	ERROR = 'ERROR',
	NEW = 'NEW',
	PROCESSING = 'PROCESSING',
	FAILED = 'FAILED',
}

export class AsyncOperationDataDetail {
	id: string;
	operationData: string;
	processingResult: string;
	sessionData: string;
}
